import { ref, toValue, watch } from 'vue'

import { formatServerDay, serverDayToDateObject } from '@/helpers/dates'
import { timeSinceLong } from '@/helpers/timeAgo'
import api from '@/store/api'

export function lifetimeTiles(lifetime) {
  const since = lifetime?.customer_since ? timeSinceLong(serverDayToDateObject(lifetime.customer_since)) : ''
  return [
    { label: 'Lifetime value', value: lifetime?.lifetime_value?.format ?? '', caption: 'all time' },
    { label: 'Orders', value: String(lifetime?.orders_count ?? ''), caption: 'paid' },
    { label: 'Avg order', value: lifetime?.average_order_value?.format ?? '-', caption: 'per order' },
    {
      label: 'Customer since',
      value: formatServerDay(lifetime?.customer_since) || 'No orders yet',
      caption: [since, lifetime?.membership_tier_name].filter(Boolean).join(' · '),
      compact: true
    }
  ]
}

export function lifetimeInlineStats(lifetime) {
  if (!lifetime) return []
  const stats = [
    { key: 'lifetime', value: lifetime.lifetime_value?.format ?? '', label: 'lifetime', drop: false },
    {
      key: 'orders',
      value: String(lifetime.orders_count ?? 0),
      label: lifetime.orders_count === 1 ? 'order' : 'orders',
      drop: false
    },
    { key: 'avg', value: lifetime.average_order_value?.format ?? '-', label: 'avg', drop: true },
    { key: 'tier', value: '', label: lifetime.membership_tier_name ?? '', drop: true }
  ]
  return stats.filter(stat => stat.value || stat.label)
}

export function paidOrdersSummary(lifetime) {
  if (!lifetime) return ''
  const count = lifetime.orders_count ?? 0
  return `${count} paid ${count === 1 ? 'order' : 'orders'} · ${lifetime.lifetime_value?.format ?? ''} lifetime`
}

export function useCustomerLifetimeStats(idSource) {
  const state = ref('idle')
  const lifetime = ref(null)

  const load = async () => {
    const id = toValue(idSource)
    lifetime.value = null
    if (id === null || id === undefined) {
      state.value = 'idle'
      return
    }
    state.value = 'loading'
    try {
      const res = await api.call('GET', `conversation_user_pairs/${id}/lifetime_stats`, {}, { receive: false })
      if (id === toValue(idSource)) {
        lifetime.value = res?.data?.data ?? null
        state.value = 'ready'
      }
    } catch (e) {
      if (id === toValue(idSource)) state.value = 'error'
    }
  }

  watch(() => toValue(idSource), load, { immediate: true })

  return { state, lifetime, reload: load }
}
